module.exports = __webpack_public_path__ + "img/3.de9a2cb6.png";